import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { Observable, ObservedValueOf } from 'rxjs';

// ERP Configuration Interfaces
export interface ERPConfigRequest {
  plantCode: string;
}

export interface ERPConfigData {
  isLotCodeDropdown: string | boolean;
  isWasteOutpuField: boolean;
  isRemarksField: boolean;
  plantCode: string;
  userCode: string;
}

export interface ERPConfigResponse {
  ERPConfig: {
    isLotCodeDropdown: string | boolean;
    isWasteOutpuField: boolean;
    isRemarksField: boolean;
  } | null;
}

export interface ERPConfigSaveResponse {
  HasError: boolean;
  Result?: string;
  ErrorMessage?: string;
}

@Injectable({
  providedIn: 'root',
})
export class SfdcConfigurationService {

  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) {}


    // ERP Config
    GetERPConfig(data: ERPConfigRequest): Observable<ERPConfigResponse> {
      return this.http.post<ERPConfigResponse>(
        this.baseUrl + 'SFDCConfiguration/GetERPConfig',
        data
      );
    }

    SaveERPConfig(data: ERPConfigData): Observable<ERPConfigSaveResponse> {
      return this.http.post<ERPConfigSaveResponse>(
        this.baseUrl + 'SFDCConfiguration/SaveERPConfig',
        data
      );
    }

    UpdateERPConfig(data: ERPConfigData): Observable<ERPConfigSaveResponse> {
      return this.http.post<ERPConfigSaveResponse>(
        this.baseUrl + 'SFDCConfiguration/UpdateERPConfig',
        data
      );
    }






  //Kpi Parameter
  SubmitKpiParameter(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.baseUrl + 'SFDCConfiguration/SubmitKpiParameter',
      data
    );
  }

  GetKpiParam(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.baseUrl + 'SFDCConfiguration/GetKpiParamTbl',
      data
    );
  }

  UpdateKpiParameter(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.baseUrl + 'SFDCConfiguration/UpdateKpiParameter',
      data
    );
  }
  DeleteKpiParam(id: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + `SFDCConfiguration/DeleteKpiParam?id=${id}`,
      {}
    );
  }

  //LotCode
  GETLotcodeMachineMapping(id: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'SFDCConfiguration/GETLotcodeMachineMappingTbl',
      id
    );
  }
  SubmitLotcodeMachineMapping(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'SFDCConfiguration/SubmitLotcodeMachineMapping',
      data
    );
  }
  updateLotcodeMachineMapping(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'SFDCConfiguration/UpdateLotcodeMachineMapping',
      data
    );
  }
  DeleteLotCode(id: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + `SFDCConfiguration/DeleteLotCode?id=${id}`,
      {}
    );
  }

  //Product Output

  GETBatchCheckListType(id: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'SFDCConfiguration/GETBatchCheckListTypeTbl',
      id
    );
  }

  SubmitBatchCheckListType(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'SFDCConfiguration/SubmitBatchCheckListType',
      data
    );
  }
  updateBatchCheckListType(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'SFDCConfiguration/UpdateBatchCheckListType',
      data
    );
  }
  DeleteBatchCheckListType(id: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + `SFDCConfiguration/DeleteBatchCheckListType?id=${id}`,
      {}
    );
  }
  //GetTapeNameDDL
  GetTapeNameDDL(): Observable<any> {
    return this.http.get<any>(
      this.baseUrl + 'SFDCConfiguration/GetTapeNameDDL'
    );
  }
  //Waste
  //GET //Id: 37
  //or
  //PU_ID: 2
  //TapName:
  //TapName: NULL GETHtmlLableTbl
  GETHtmlLable(id: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'SFDCConfiguration/GETHtmlLableTbl',
      id
    );
  }
  //SubmitHtmlLable
  //     PU_ID: 2
  // Name: asd
  // Result: asd
  // UoM: aasd
  // TN_ID: 1
  // UserId: 100001
  // BatchListId:
  SubmitHtmlLable(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'SFDCConfiguration/SubmitHtmlLable',
      data
    );
  }
  //UpdateHtmlLable
  // PU_ID: 2
  // Name: asd
  // Result: asd
  // UoM: aasd
  // TN_ID: 1
  // UserId: 100001
  // BatchListId:
  // Id: 172
  UpdateHtmlLable(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'SFDCConfiguration/UpdateHtmlLable',
      data
    );
  }
  DeleteHtmlLable(id: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + `SFDCConfiguration/DeleteHtmlLable?id=${id}`,
      {}
    );
  }

  //map short stop fault
  GetMapFault(data: any): Observable<any> {
    // return this.http.post<any>(this.baseUrl + 'SDFC/GetFaultByUnit', data);
    return this.http.post<any[]>(this.baseUrl + 'common/getFaultByUnit', data);
  }

  SaveMapFault(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'SFDCConfiguration/SubmitFaultMapping',
      data
    );
  }

  getMapFaultList(id: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'SFDCConfiguration/GETShortStopsFaultsTbl',
      id
    );
  }

  DeleteMapFault(id: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + `SFDCConfiguration/DeleteSSFault?id=${id}`,
      {}
    );
  }

  //map short stop fault

  SaveMapShortDuration(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'SFDCConfiguration/SubmitSSDMapping',
      data
    );
  }

  getMapShortDurationList(id: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'SFDCConfiguration/GETShortStopsDurationTbl',
      id
    );
  }

  DeleteMapDuration(id: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + `SFDCConfiguration/DeleteSSDuration?id=${id}`,
      {}
    );
  }

  SubmitBatchdropdownListType(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'SFDCConfiguration/SubmitBatchdropdownListType',
      data
    );
  }

  GetDropDownBatchCheckList(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'SDFC/GetDropDownBatchCheckList',
      data
    );
  }

  GetFeaturesSFDC(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'SFDCConfiguration/GetFeaturesSFDC',
      data
    );
  }

  FeatureEnableDisableSFDC(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'SFDCConfiguration/FeatureEnableDisableSFDC',
      data
    );
  }

  SubmitIsBatchConsumption(data: any): Observable<any> {
    return this.http.post<any>(
      this.baseUrl + 'SFDCConfiguration/SubmitIsBatchConsumption',
      data
    );
  }
}
